import { COLORS } from '@btime/constants'
import { formatDate } from '@btime/helpers'
import React from 'react'
import DataTable from '../../../packages/kiti/components/table/DataTable'
import { useAudits } from '../_load/AuditLoader'
import ListCounter from '../../../components/helpers/ListCounter'
import { RefetchingIndicator } from '../../../packages/kiti/components/helpers/StatePresenter'
import { auditClient } from '../../../utils/apollo/api'
import { useModalData } from '../../../components/modals/ModalsContext'
import Text from '../../../packages/kiti/components/presentation/Text'
import { useRowActionsColumn } from '../../../components/tables/Table'
import { useTranslation } from 'react-i18next'

const AuditTable = ({ openDetail }) => {
  const { t } = useTranslation('audit')
  const serviceOrderId = useModalData()
  const audits = useAudits()
  const columns = [
    {
      label: t('fields.createdBy'),
      headerSideContent: (
        <>
          <ListCounter
            client={auditClient}
            entity={'audits'}
            filterName="AuditFilter"
            filters={{
              recordId: serviceOrderId,
              entity: 'service_order'
            }}
          />
          <RefetchingIndicator />
        </>
      ),
      dataIndex: ['createdBy', 'name'],
      sortIndex: false,
      flex: 4
    },
    {
      label: t('operation'),
      dataIndex: 'operation',
      sortIndex: false,
      flex: 4,
      render: operation => {
        let text
        switch (operation) {
          case 'create':
            text = t('operations.create')
            break
          case 'update':
            text = t('operations.update')
            break
          case 'remove':
            text = t('operations.remove')
            break
          default:
            text = t('operations.notSupported')
        }

        return (
          <Text strong color={COLORS.dark2} breakWord>
            {text}
          </Text>
        )
      }
    },

    {
      label: t('date'),
      dataIndex: 'insertedAt',
      format: formatDate('DD/MM/YYYY HH:mm'),
      flex: 2
    },

    {
      label: t('common:actions'),
      flex: 1,
      render: useRowActionsColumn(record => {
        return [
          {
            value: t('seeDetails'),
            icon: 'RiSearchLine',
            onClick: () => {
              openDetail(record)
            }
          }
        ]
      })
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={audits} inPanel size="medium" />
}

export default AuditTable
